import { enClientPortalDashboardHistoryChart } from './Dashboard/DashboardHistoryChart'
import { enClientPortalDashboardPage } from './Dashboard/Dashboard'
import { enClientPortalNewsFromEinwertWidget } from './Dashboard/NewsFromEinwertWidget'

export const enClientPortalDashboardPages = {
    dashboard: {
        dashboard: enClientPortalDashboardPage,
        dashboardHistoryChart: enClientPortalDashboardHistoryChart,
        newsFromEinwertWidget: enClientPortalNewsFromEinwertWidget,
    },
}
